import React from "react";
export default class TagIcon extends React.Component {
    render() {
        return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path fill-rule="evenodd" clip-rule="evenodd" d="M17.2929 20.7071C17.5789 20.9931 18.009 21.0787 18.3827 20.9239C18.7564 20.7691 19 20.4045 19 20V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V20C5 20.4045 5.24364 20.7691 5.61732 20.9239C5.99099 21.0787 6.42111 20.9931 6.70711 20.7071L12 15.4142L17.2929 20.7071ZM7 4C6.44772 4 6 4.44772 6 5V8L18 8V5C18 4.44772 17.5523 4 17 4H7ZM18 9L6 9L6 20L11.2929 14.7071C11.6834 14.3166 12.3166 14.3166 12.7071 14.7071L18 20V9Z" fill="#0C172F"/>
			</svg>);
    }
}
